import React from 'react';
import { rootRoute } from '@/modules/core/root/route';
import { createRoute } from '@tanstack/react-router';
import * as z from 'zod';

export const emailValidationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'email-validation',
  component: React.lazy(async () => await import('@/app/routes/ValidateAppEmail')),
  validateSearch: z.object({
    token: z.string().optional(),
  }),
  wrapInSuspense: true,
});
